import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    debugger;
    //let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const authReq = request.clone({
        headers: new HttpHeaders({
          //'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentUser}`
        })
      });

      const cloneReq = request.clone(authReq);
      return next.handle(cloneReq);
    }

    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/jwt.interceptor.ts